module.exports = __webpack_public_path__ + "Icono_ATQ-Bco_512px.png";